import { render, staticRenderFns } from "./CustomDataColumn.vue?vue&type=template&id=1a1b015c"
import script from "./CustomDataColumn.vue?vue&type=script&lang=js"
export * from "./CustomDataColumn.vue?vue&type=script&lang=js"
import style0 from "./CustomDataColumn.vue?vue&type=style&index=0&id=1a1b015c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports